import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockLegend } from '../../Components/Public/Blocks/BlockLegend.js';
import { BlockLogoCategories } from '../../Components/Public/Logos/BlockLogoCategories.js';
import { BlockTitleDate1Link1 } from '../../Components/Public/Blocks/BlockTitleDate1Link1.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Category = (props) => {
    const { navParks, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [attractions, setAttractions] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasAttractions = await fetch(`${backend}/attractions_by_category?id=${id}`, GetHeaders(guest));
            const attractions = await datasAttractions.json();
            setAttractions(attractions);
        };
        fetchData();
        ScrollTop();
    }, [backend, id, guest]);
    const items = GetDescription('category', { attractions: attractions })
    return (
        <div className="category">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="category" />
            <section className="infos">
                <div className="list">
                    <BlockLegend parks={navParks} total={attractions.length} />
                    {attractions.map((item, i) => {
                        return (
                            <BlockLogoCategories label="category" item={item} key={i} />
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleDate1Link1 label="category" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}